import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }

  public getCurrentUrl() {
    return window.location.href;
  }
}
